(function() {
    angular
        .module('ngmvac')
        .directive('alertTime', AlertTime);

    function AlertTime() {
        return {
            template:   '<div class="alert-back" ng-show="timeExpired">'+
                            '<div class="alert-box">'+
                                '<div class="" ng-transclude>'+
                                '</div>'+
                            '</div>'+
                        '</div>',
            restrict: 'AE',
            transclude: true,
            scope: {
                timeExpired: '='
            },
            link: function(scope, element, attrs) {

            }
        }
    }

})();
